// 存储数据到localStorage中，并设置超时时间（以毫秒为单位）
function setItem(key, value) {
  const item = {
    value: value,
    timeout: Date.now() + (60 * 60 * 1000)
  };
  localStorage.setItem(key, JSON.stringify(item));
}

// 获取数据，并检查超时
function getItem(key) {
  const item = JSON.parse(localStorage.getItem(key));
  if (item && Date.now() < item.timeout) {
    return item.value;
  }
  localStorage.removeItem(key)
  // 超时或数据不存在时返回null或其他默认值
  return null;
}

export default {
  setItem,
  getItem
}
